import React, { useState, useEffect, useRef } from 'react';
import apiClient from '../../../../../../Config/apiClient';
import { showSuccessToast, showErrorToast } from '../../../../../../Context/Toaster/Toaster';
import Loader from '../../../../../../Context/Loader/Loader';
import closeIcon from '../../../../../../Assets/images/modal-close.svg';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../Utils/Constants';
import './ViewReplyModal.scss';

const contactInquiriesPath = process.env.REACT_APP_HS_CONTACT_INQUIRIES_BASE_PATH;

const ViewReplyModal = ({ show, inquiry, onClose, onUpdate }) => {
  const [localStatus, setLocalStatus] = useState('');
  const [replyNotes, setReplyNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [validationError, setValidationError] = useState('');
  const autoMarkedRef = useRef(null);

  useEffect(() => {
    if (inquiry) {
      setLocalStatus(inquiry.status || '');
      setReplyNotes(inquiry.reply_notes || '');
      setValidationError('');
    }
  }, [inquiry]);

  useEffect(() => {
    if (show && inquiry?.id && inquiry.status === 'New' && autoMarkedRef.current !== inquiry.id) {
      autoMarkedRef.current = inquiry.id;
      apiClient.put(`${contactInquiriesPath}/${inquiry.id}`, { status: 'Read' })
        .then(() => onUpdate())
        .catch(() => {});
    }
  }, [show, inquiry?.id]);

  const handleSave = async () => {
    if (localStatus === 'Replied' && (!replyNotes || !replyNotes.trim())) {
      setValidationError('Reply notes are required when setting status to Replied.');
      return;
    }
    setValidationError('');
    setSaving(true);
    try {
      await apiClient.put(`${contactInquiriesPath}/${inquiry.id}`, {
        status: localStatus,
        reply_notes: replyNotes || undefined,
      });
      showSuccessToast('Inquiry updated successfully');
      onUpdate();
      onClose();
    } catch (err) {
      showErrorToast(err?.response?.data?.error_data?.message || 'Failed to update inquiry');
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content setm-content">
          <div className="modal-body stem-body">
            <div className="add-modal">
              <div className="am-head">
                <h2>Contact Inquiry Details</h2>
                <button type="button" className="m-close" onClick={onClose}>
                  <img src={closeIcon} alt="Close" />
                </button>
              </div>
              <div className="am-content">
                <div className="cp-form">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="cp-split">
                        <label className="fi-label">Name</label>
                        <input type="text" className="common-input readonly-input" value={inquiry?.name || ''} disabled />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="cp-split">
                        <label className="fi-label">Email</label>
                        <input type="text" className="common-input readonly-input" value={inquiry?.email || ''} disabled />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="cp-split">
                        <label className="fi-label">Message</label>
                        <textarea className="common-text readonly-input" value={inquiry?.message || ''} disabled rows="3" />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="cp-split">
                        <label className="fi-label">IP Address</label>
                        <input type="text" className="common-input readonly-input" value={inquiry?.ip_address || '—'} disabled />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="cp-split">
                        <label className="fi-label">Submitted At</label>
                        <input type="text" className="common-input readonly-input" value={inquiry?.submitted_at ? moment(inquiry.submitted_at).local().format(DATE_TIME_FORMAT) : '—'} disabled />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="cp-split">
                        <label className="fi-label">Status</label>
                        <select
                          className="common-select"
                          value={localStatus}
                          onChange={(e) => { setLocalStatus(e.target.value); setValidationError(''); }}
                        >
                          <option value="New">New</option>
                          <option value="Read">Read</option>
                          <option value="Replied">Replied</option>
                          <option value="Archived">Archived</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="cp-split">
                        <label className="fi-label">Reply Notes</label>
                        <textarea
                          className="common-text"
                          value={replyNotes}
                          onChange={(e) => { setReplyNotes(e.target.value); setValidationError(''); }}
                          rows="4"
                          placeholder="Enter reply notes..."
                        />
                        {validationError && (
                          <span className="error-text active">{validationError}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="m-button">
                    <button className="update-button" style={{ width: '105px' }} onClick={handleSave} disabled={saving}>
                      {saving ? <Loader /> : 'Save'}
                    </button>
                    <button className="cancel-button me-4 float-end" onClick={onClose}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReplyModal;
